import { CpRefundOnlineProcessResponseInterface } from '../../../interfaces/response/refund-online-process/cp-refund-online-process-response-interface';
import { PaginationModel } from '@fh-client-interaction-frontends/fh-providers';
import { CpRefundOnlineProcessModel } from '../../dto/refund-online-process/cp-refund-online-process-model';

export class CpRefundOnlineProcessResponseModel implements CpRefundOnlineProcessResponseInterface {
  PaginationResult: PaginationModel = new PaginationModel();
  RefundSubmissions: CpRefundOnlineProcessModel[] = new Array<CpRefundOnlineProcessModel>();

  constructor(init?: Partial<CpRefundOnlineProcessResponseModel>) {
    Object.assign(this, init);
  }
}
